export function getValuePool(value = 0) {
  if (value <= 100000) return "0 - 100K";
  if (value <= 250000) return "100K - 250K";
  if (value <= 1000000) return "250K - 1M";
  if (value <= 5000000) return "1M - 5M";
  return "5M+";
}
